(function() {
  'use strict';
  
  const isBlogPost = document.body.classList.contains('template-lbd-blog-post') || 
                     document.documentElement.classList.contains('template-lbd-blog-post') ||
                     document.querySelector('[class*="template-lbd-blog-post"]') ||
                     document.querySelector('.lbd-blog-post-class');
  
  if (!isBlogPost) {
    return;
  }
  
  const config = {
    shareButtonPattern: /^Share-/,
    quickLinksClass: 'quick-links-container',
    quickLinksListClass: 'quick-links-list'
  };

  function generateId(text) {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .trim();
  }

  function findBlogContainer() {
    return document.querySelector('.lbd-blog-post-class');
  }

  function findRelevantHeaders() {
    const blogContainer = findBlogContainer();
    
    if (!blogContainer) {
      return [];
    }
    
    const allH1s = blogContainer.querySelectorAll('.h1, h1');
    return Array.from(allH1s);
  }

  function processHeaders(headers) {
    return headers.map(header => {
      const text = header.textContent.trim();
      
      if (!header.id) {
        header.id = generateId(text);
      }
      
      return {
        id: header.id,
        text: text
      };
    });
  }

  function createQuickLinksElement(headerData) {
    const container = document.createElement('div');
    container.className = config.quickLinksClass;
    container.style.cssText = `
      padding: var(--lbd-standard-margin) 0;
      border-bottom: var(--lbd-line-width) solid var(--lbd-text-color);
      margin-bottom: var(--lbd-standard-margin);
    `;

    const list = document.createElement('ul');
    list.className = config.quickLinksListClass;
    list.style.cssText = `
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      gap: calc(var(--lbd-minor-margin) / 2) var(--lbd-standard-margin);
    `;

    const headerItem = document.createElement('li');
    headerItem.className = 'h2';
    headerItem.textContent = 'Contents';
    list.appendChild(headerItem);

    headerData.forEach(header => {
      const listItem = document.createElement('li');
      
      const link = document.createElement('a');
      link.href = `#${header.id}`;
      link.textContent = header.text;
      link.className = 'lbd-link';
      link.style.cssText = `
        text-decoration: none;
        transition: opacity 0.2s ease;
      `;
      
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById(header.id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
          history.pushState(null, '', `#${header.id}`);
        }
      });
      
      listItem.appendChild(link);
      list.appendChild(listItem);
    });

    container.appendChild(list);
    
    return container;
  }

  function findShareButton() {
    const allElements = document.querySelectorAll('[id]');
    
    for (let element of allElements) {
      if (config.shareButtonPattern.test(element.id)) {
        return element;
      }
    }
    
    return document.querySelector('share-button, .share-button');
  }

  function injectQuickLinks(quickLinksElement) {
    const shareButton = findShareButton();
    
    if (!shareButton) {
      console.error('Could not find share button for quick links insertion');
      return false;
    }
    
    const parentRow = shareButton.closest('.row');
    
    if (parentRow) {
      const newRow = document.createElement('div');
      newRow.className = 'row';
      newRow.style.paddingTop = 'var(--lbd-large-margin)';
      
      const newCol = document.createElement('div');
      newCol.className = 'col';
      newCol.appendChild(quickLinksElement);
      
      newRow.appendChild(newCol);
      
      parentRow.parentNode.insertBefore(newRow, parentRow.nextSibling);
    } else {
      shareButton.parentNode.insertBefore(quickLinksElement, shareButton.nextSibling);
    }
    
    return true;
  }

  function init() {
    const headers = findRelevantHeaders();
    
    if (headers.length === 0) {
      return;
    }
    
    const headerData = processHeaders(headers);
    const quickLinksElement = createQuickLinksElement(headerData);
    
    injectQuickLinks(quickLinksElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
